import React from "react";
import { Navigate, Outlet } from "react-router-dom";

/**
 * This component is parent for wrap all survey routes, and is a guard for check if feature is enabled on client project
 * If it is, the user will be redirected to home, otherwise to the survey page
 */
const SpacesRootRoute: React.FC = () => {
  // is survey feature enabled ?
  const isEnabled = true;

  if (!isEnabled) {
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
};

export default SpacesRootRoute;
